import {
    // FILE_UPLOAD,
    CREATE_ADMIN_REQUEST_STAFF_TRANSFER,
    FULL_TRANSFER_REQUEST_STAFF_TRANSFER,
    INFO_TRANSFER_REQUEST_STAFF_TRANSFER,
    DENY_TRANSFER_REQUEST_STAFF_TRANSFER,
    DELETE_TRANSFER_REQUEST_STAFF_TRANSFER,
    RETRIEVE_ADMIN_REQUEST_STAFF_TRANSFER,
    // RETRIEVE_ARCHITECTURECOMPANYCONVERTEDLEADS,
    // RETRIEVE_ARCHITECTURECOMPANYPENDINGLEADS,
    RETRIEVESINGLE_ADMIN_REQUEST_STAFF_TRANSFER,
    UPDATE_ADMIN_REQUEST_STAFF_TRANSFER,
    DELETE_ADMIN_REQUEST_STAFF_TRANSFER,
    // RETRIEVE_ARCHITECTURESERVERSTAFF,
    // RETRIEVE_ARCHITECTURESERVERSERVICEUSERS,
} from "./type";
import AdminRequestStaffTransfer from "../service/AdminRequestStaffTransfer";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await AdminRequestStaffTransfer.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await AdminRequestStaffTransfer.create(data);
        dispatch({
            type: CREATE_ADMIN_REQUEST_STAFF_TRANSFER,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const full_transfer = (data) => async (dispatch) => {
    try {
        const res = await AdminRequestStaffTransfer.full_transfer(data);
        // dispatch({
        //     type: FULL_TRANSFER_REQUEST_STAFF_TRANSFER,
        //     payload: res.data,
        // });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const info_transfer = (data) => async (dispatch) => {
    try {
        const res = await AdminRequestStaffTransfer.info_transfer(data);
        // dispatch({
        //     type: INFO_TRANSFER_REQUEST_STAFF_TRANSFER,
        //     payload: res.data,
        // });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const deny_transfer_request = (data) => async (dispatch) => {
    try {
        const res = await AdminRequestStaffTransfer.deny_transfer_request(data);
        // dispatch({
        //     type: DENY_TRANSFER_REQUEST_STAFF_TRANSFER,
        //     payload: res.data,
        // });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const delete_transfer_request = (data) => async (dispatch) => {
    try {
        const res = await AdminRequestStaffTransfer.delete_transfer_request(data);
        // dispatch({
        //     type: DELETE_TRANSFER_REQUEST_STAFF_TRANSFER,
        //     payload: res.data,
        // });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await AdminRequestStaffTransfer.fetchList(data);
        dispatch({
            type: RETRIEVE_ADMIN_REQUEST_STAFF_TRANSFER,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await AdminRequestStaffTransfer.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ADMIN_REQUEST_STAFF_TRANSFER,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await AdminRequestStaffTransfer.update(data);
        dispatch({
            type: UPDATE_ADMIN_REQUEST_STAFF_TRANSFER,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await AdminRequestStaffTransfer.changeStatus(data);
//         dispatch({
//             type: UPDATE_ADMIN_REQUEST_STAFF_TRANSFER,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await AdminRequestStaffTransfer.trash(data);
        dispatch({
            type: DELETE_ADMIN_REQUEST_STAFF_TRANSFER,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};